<div class="radio-wrapper">
    <label class="radio-label" *ngIf="field.label">
        {{ field.label }} <span class="required" *ngIf="field.required"> *</span>
    </label>
    <mat-radio-group [value]="value" [disabled]="disabled" (change)="onChange($event.value)" (blur)="onTouched()">
        <mat-radio-button *ngFor="let option of field.options" [value]="option.value" class="mr-4">
            {{ option.label }}
        </mat-radio-button>
    </mat-radio-group>
    <small class="error" *ngIf="errorMessage">
        {{ errorMessage }}
    </small>
</div>